import i18next from 'i18next';

i18next.addResources('es', 'investmentSelector', {
  investment: 'Inversión',
  usMillions: 'Millones de USD',
  apply: 'Aplicar'
});

i18next.addResources('en', 'investmentSelector', {
  investment: 'Investment',
  usMillions: 'Millions of USD',
  apply: 'Apply'
});

i18next.addResources('pt', 'investmentSelector', {
  investment: 'Investimento',
  usMillions: 'Milhões de USD',
  apply: 'Aplicar'
});
